import { ethersWeb3Provider, providerOAS } from '~/blockchain/oas';
import { numberToHex } from '~/blockchain/provider';

export const sendOASTransaction = async (transactionData) => {
  try {
    if (!providerOAS || !providerOAS.accounts || !providerOAS.accounts[0]) {
      throw new Error('OAS provider not connected');
    }

    if (!transactionData.to) {
      throw new Error('Transaction to address is required');
    }

    // const nonce = await providerOAS.request({
    //   method: 'eth_getTransactionCount',
    //   params: [providerOAS.accounts[0], 'latest']
    // });

    const value = transactionData.value || 0;
    const valueHex = typeof value === 'string' && value.startsWith('0x') 
      ? value 
      : numberToHex(value);

    let gasLimit = transactionData.gasLimit;
    
    if (!gasLimit) {
      try {
        const estimatedGas = await ethersWeb3Provider.estimateGas({
          from: providerOAS.accounts[0],
          to: transactionData.to,
          data: transactionData.data,
          value: valueHex,
        });
        gasLimit = Math.floor(estimatedGas.toNumber() * 1.2); 
      } catch (gasError) {
        console.warn('Gas estimation failed, using default:', gasError);
        gasLimit = 2000000; 
      }
    }

    let gasPrice;
    try {
      const gasPriceResponse = await ethersWeb3Provider.getGasPrice();
      const gasPriceValue = gasPriceResponse.toNumber();
      
      if (gasPriceValue === 0) {
        gasPrice = '0x1'; 
      } else {
        gasPrice = gasPriceResponse.toHexString();
      }
    } catch (gasPriceError) {
      console.warn('Failed to get gas price, using default');
      gasPrice = '0x1'; 
    }

    const data = {
      from: String(providerOAS.accounts[0]),
      to: String(transactionData.to),
      value: String(valueHex),
      data: String(transactionData.data || '0x'),
      gas: `0x${Number(gasLimit).toString(16)}`,
      gasPrice: String(gasPrice),
      // nonce: `0x${nonce.toString(16)}`,
    };

    Object.keys(data).forEach(key => {
      if (data[key] === undefined || data[key] === null || data[key] === '') {
        delete data[key];
      }
    });

    Object.keys(data).forEach(key => {
      if (typeof data[key] !== 'string') {
        console.warn(`Transaction field ${key} is not a string:`, typeof data[key], data[key]);
        data[key] = String(data[key]);
      }
    });

    
    
    const transactionHash = await providerOAS.request({
      method: 'eth_sendTransaction',
      params: [data],
    });

    if (!transactionHash || typeof transactionHash !== 'string') {
      throw new Error('Invalid transaction hash received from wallet');
    }

    return { hash: transactionHash };
  } catch (error) {
    console.error('Error sending OAS transaction:', error);
    
    if (error.code === 5000) {
      throw new Error(`Transaction failed: ${error.message}. This might be due to insufficient gas, invalid parameters, or network issues.`);
    } else if (error.code === 4001) {
      throw new Error('Transaction rejected by user');
    } else if (error.message?.includes('insufficient funds')) {
      throw new Error('Insufficient funds for transaction');
    } else if (error.message?.includes('gas')) {
      throw new Error('Gas estimation failed or insufficient gas limit');
    } else {
      throw error;
    }
  }
};
